module.exports = __webpack_public_path__ + "img/6.0b365f67.png";